var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-white border-b border-border header-bottom z-100",
      class: {
        "header-bottom--collapsed": _vm.collapsed,
        "fixed w-full top-0": _vm.fixed,
        hidden: _vm.fixed && _vm.hideFixedHeader,
        invisible: !_vm.fixed && !_vm.hideFixedHeader,
        relative: !_vm.fixed
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "container flex items-center justify-between mx-auto h-full flex-wrap px-1"
        },
        [
          _c(
            "div",
            { staticClass: "w-1-3 xl_w-1-4 header-bottom__search" },
            [
              _c("buyer-input", {
                attrs: {
                  placeholder: "Search",
                  type: "search",
                  value: _vm.search
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("search-input", $event)
                  },
                  search: function($event) {
                    return _vm.$emit("perform-search", $event)
                  }
                }
              })
            ],
            1
          ),
          _vm._t("default"),
          _c(
            "div",
            {
              staticClass: "flex items-center w-1-3 justify-end",
              class:
                _vm.isWhitelabel && _vm.showHomeLink ? "xl_w-1-3" : "xl_w-1-4"
            },
            [
              _vm.isWhitelabel
                ? [
                    _vm.showHomeLink
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "text-xl cursor-pointer mr-1 lg_mr-1_5 xl_mr-2 select-none",
                            attrs: {
                              tabindex: "0",
                              tag: "div",
                              to: { name: "home" }
                            }
                          },
                          [_vm._v("Home")]
                        )
                      : _vm._e(),
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-xl cursor-pointer mr-1 lg_mr-1_5 xl_mr-2 select-none",
                        attrs: {
                          tabindex: "0",
                          tag: "div",
                          to: { name: "trackOrder" }
                        }
                      },
                      [_vm._v("Track Order")]
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "text-xl cursor-pointer select-none",
                        class: _vm.cartQuantity
                          ? "mr-1 lg_mr-1_5 xl_mr-2"
                          : null,
                        attrs: {
                          tabindex: "0",
                          tag: "div",
                          to: { name: "contact" }
                        }
                      },
                      [_vm._v("Contact")]
                    )
                  ]
                : [
                    !_vm.isWhitelabel && _vm.marketplaceCategories.length
                      ? _c(
                          "div",
                          {
                            ref: "shopByMenu",
                            staticClass:
                              "text-xl mr-1 lg_mr-1_5 xl_mr-2 relative cursor-pointer select-none",
                            attrs: { tabindex: "0" },
                            on: {
                              click: _vm.toggleShopMenu,
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.toggleShopMenu($event)
                              }
                            }
                          },
                          [
                            _vm._v("Shop By"),
                            _c("icon-chevron-down", {
                              staticClass: "ml-_5 text-brand"
                            }),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showShopByMenu,
                                    expression: "showShopByMenu"
                                  }
                                ],
                                staticClass:
                                  "header-bottom__shop-by-menu absolute left-0 rounded bg-white z-10 overflow-auto"
                              },
                              _vm._l(_vm.marketplaceCategories, function(
                                category
                              ) {
                                return _c(
                                  "router-link",
                                  {
                                    key: category.slug,
                                    staticClass: "text-lg",
                                    attrs: {
                                      tabindex: "0",
                                      tag: "div",
                                      to: _vm.marketplaceRoute(category)
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "transition-250 transition-color hover_text-brand cursor-pointer block px-1 py-_25"
                                      },
                                      [_vm._v(_vm._s(category.text))]
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "router-link",
                      {
                        staticClass: "text-xl cursor-pointer",
                        class: _vm.cartQuantity
                          ? "mr-1 lg_mr-1_5 xl_mr-2"
                          : null,
                        attrs: {
                          tabindex: "0",
                          tag: "div",
                          to: { name: "openShop" }
                        }
                      },
                      [_vm._v("Start Selling")]
                    )
                  ],
              _vm.cartQuantity
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "div",
                        to: { name: "cart", params: { id: _vm.cart.id } }
                      }
                    },
                    [
                      _c("icon-cart", {
                        staticClass: "text-brand",
                        attrs: { qty: _vm.cartQuantity }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }